import { render } from "./MiExpansionItem.vue?vue&type=template&id=0c52f83f&scoped=true"
import script from "./MiExpansionItem.vue?vue&type=script&lang=js"
export * from "./MiExpansionItem.vue?vue&type=script&lang=js"

import "./MiExpansionItem.vue?vue&type=style&index=0&id=0c52f83f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c52f83f"]])

export default __exports__
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QItem from 'quasar/src/components/item/QItem.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QExpansionItem,QItem});
